import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // initialise i18next before App mounts (Phase B)
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();

// --- Optional, environment-gated integrations -------------------------------
// Nothing below runs unless the matching REACT_APP_* variable is set, so the
// bundle stays clean for deployments that don't use these services.

// Privacy-friendly analytics (Plausible). Enable by setting
// REACT_APP_PLAUSIBLE_DOMAIN to the site domain registered at Plausible.
const plausibleDomain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
if (plausibleDomain) {
  const script = document.createElement("script");
  script.defer = true;
  script.dataset.domain = plausibleDomain;
  script.src = "https://plausible.io/js/script.js";
  document.head.appendChild(script);
}

// Error monitoring (Sentry). Enable by setting REACT_APP_SENTRY_DSN.
// Loaded lazily so the Sentry SDK never enters the main bundle when unset.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: sentryDsn,
      environment: process.env.NODE_ENV || "development",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
    });
  });
}
